/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_FileInputs */

const cs_enum_file = /** @type {(inputs: Enum_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soubor`)
};

const en_enum_file = /** @type {(inputs: Enum_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

/**
* | output |
* | --- |
* | "File" |
*
* @param {Enum_FileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_file = /** @type {((inputs?: Enum_FileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_FileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_file(inputs)
	return cs_enum_file(inputs)
});